import type { IconName } from "../../components/ui/icon";
import type { WidgetConfig } from "./types";
import type { WidgetModule } from "./widget-module";
import type { Omittable } from "../../lib/props";

/**
 * Add-Card preset — one tile in the view card gallery, flattened from each
 * widget module's `catalog` entries (stamped with the module's `type` and `icon`
 * fallback). Author a widget by adding a `catalog` entry to its module; nothing
 * here is hand-maintained. `section` is an open string the gallery groups by.
 */
export type WidgetPreset = Omittable<{
  key: string;
  type: string;
  label: string;
  description: string;
  icon: IconName;
  section: string;
  /** Data-source tags (opaque strings) shown as gallery chips + search terms. */
  tags?: readonly string[];
  defaultConfig: WidgetConfig;
  defaultW?: number;
  defaultH?: number;
  /** Whether an instance auto-titles from `label` (default true; false = stays
   *  untitled). Consumed by the view store's initial-config rule. (U2) */
  autoTitle?: boolean;
}>;

/** Flatten a registry's modules into the Add-Card gallery presets. */
export function buildPresets(modules: WidgetModule[]): WidgetPreset[] {
  return modules.flatMap((def) =>
    (def.catalog ?? []).map((e) => ({
      key: e.key,
      type: def.type,
      label: e.label,
      description: e.description,
      icon: e.icon ?? def.icon,
      section: e.section,
      tags: e.tags,
      defaultConfig: (e.defaultConfig ?? {}) as WidgetConfig,
      defaultW: e.defaultW,
      defaultH: e.defaultH,
      autoTitle: e.autoTitle,
    })),
  );
}
